import groupsReducer from './groupsReducer';

export default groupsReducer;
